/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.booking').service('bookingShiftCommentEditMode', function() {

  const EDIT_MODE_ONLY_CURRENT = 1;
  const EDIT_MODE_FOLLOWING = 2;

  return {
    getOnlyCurrentMode() {
      return EDIT_MODE_ONLY_CURRENT;
    },

    getFollowingMode() {
      return EDIT_MODE_FOLLOWING;
    }
  };
});
